import { CreditCard, Heart, Hotel } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { getAmicalValidationClassName, getAmicalValidationStatus } from '../amicalDisplay'
import { CARD_TYPE, RESERVATION_STATUS } from '../constants'
import { useCartesAccesLabels } from '../useCartesAccesLabels'

const BASE =
  'inline-flex items-center gap-1 rounded-md border border-transparent px-2.5 py-0.5 text-xs font-semibold'

export const Badge = ({ children, className = '' }) => (
  <span className={`${BASE} ${className}`}>{children}</span>
)

const CARD_TYPE_STYLES = {
  [CARD_TYPE.ACCES]: {
    cls: 'bg-[color-mix(in_oklab,var(--primary)_15%,transparent)] text-[var(--primary)]',
    Icon: CreditCard,
  },
  [CARD_TYPE.BIEN_ETRE]: {
    cls: 'bg-[var(--secondary)] text-[var(--secondary-foreground)]',
    Icon: Heart,
  },
}

export const CardTypeBadge = ({ type, className = '' }) => {
  const { cardTypeLabel } = useCartesAccesLabels()
  const meta = CARD_TYPE_STYLES[type] ?? CARD_TYPE_STYLES[CARD_TYPE.ACCES]
  const { Icon } = meta
  return (
    <Badge className={`${meta.cls} ${className}`}>
      <Icon className="h-3 w-3" aria-hidden />
      {cardTypeLabel(type) || type}
    </Badge>
  )
}

export const HotelClassBadge = ({ classe, className = '' }) => {
  const { t } = useTranslation()
  return (
    <Badge className={`bg-primary-100 text-primary-800 ${className}`}>
      <Hotel className="h-3 w-3" aria-hidden />
      {classe || t('cartesAcces.shared.badge.accommodation')}
    </Badge>
  )
}

const STATUS_STYLES = {
  [RESERVATION_STATUS.PENDING]: 'bg-amber-50 text-amber-600',
  [RESERVATION_STATUS.CONFIRMED]: 'bg-green-50 text-green-600',
  [RESERVATION_STATUS.CANCELLED]: 'bg-red-50 text-red-600',
  [RESERVATION_STATUS.USED]: 'bg-gray-100 text-gray-500',
}

export const StatusBadge = ({ status, className = '' }) => {
  const { reservationStatusLabel } = useCartesAccesLabels()
  return (
    <Badge className={`${STATUS_STYLES[status] ?? 'bg-gray-100 text-gray-500'} ${className}`}>
      {reservationStatusLabel(status) || status}
    </Badge>
  )
}

export const ActiveBadge = ({ active }) => {
  const { t } = useTranslation()
  return active ? (
    <Badge className="bg-green-50 text-green-600">{t('cartesAcces.common.active')}</Badge>
  ) : (
    <Badge className="bg-gray-100 text-gray-400">{t('cartesAcces.common.inactive')}</Badge>
  )
}

export const AmicalValidationBadge = ({ reservation, className = '' }) => {
  const { amicalValidationLabel } = useCartesAccesLabels()
  const status = getAmicalValidationStatus(reservation)
  if (!status) return <span className="text-xs text-gray-400">—</span>
  return (
    <Badge className={`ring-1 ${getAmicalValidationClassName(status)} ${className}`}>
      {amicalValidationLabel(status)}
    </Badge>
  )
}
